import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PaginaUsuariosComponent } from './pagina-usuarios/pagina-usuarios.component';
import { SubidaMasivaComponent } from './subida-masiva/subida-masiva.component';

const rutas: Routes = [
  { path: 'subida-masiva', component: SubidaMasivaComponent },
  { path: '', component: PaginaUsuariosComponent }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild( rutas )
  ],
  exports: [
    RouterModule
  ]
})
export class UsuariosRoutingModule { }
